/* Bagulia navigation drawer, 2026-10-14.
   Accessible disclosure groups. Desktop (990px and wider): every group open.
   Mobile: the Bags group (or the group holding the current page) opens first, and opening one
   group closes the others so a category is one expansion and one tap away.
   Open/close of the drawer itself, Escape, focus trap, focus return and scroll lock stay with the
   theme's header-drawer element. Without JavaScript every group simply stays open. */
(function () {
  if (window.__bglNavInit) return;
  window.__bglNavInit = true;

  var desktop = window.matchMedia('(min-width: 990px)');

  function panelFor(btn) {
    return document.getElementById(btn.getAttribute('aria-controls'));
  }

  function setOpen(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = panelFor(btn);
    if (panel) panel.hidden = !open;
  }

  function init(root) {
    var toggles = Array.prototype.slice.call(root.querySelectorAll('.bgl-nav__toggle'));
    if (!toggles.length) return;

    function applyDefaults() {
      var hasCurrent = toggles.some(function (btn) {
        var panel = panelFor(btn);
        return panel && panel.querySelector('[aria-current="page"]');
      });
      toggles.forEach(function (btn) {
        if (desktop.matches) return setOpen(btn, true);
        var group = btn.closest('.bgl-nav__group');
        var panel = panelFor(btn);
        var isCurrent = !!(panel && panel.querySelector('[aria-current="page"]'));
        var isDefault = !!(group && group.hasAttribute('data-default-open'));
        setOpen(btn, hasCurrent ? isCurrent : isDefault);
      });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (open && !desktop.matches) {
          toggles.forEach(function (other) {
            if (other !== btn) setOpen(other, false);
          });
        }
        setOpen(btn, open);
      });
    });

    applyDefaults();
    if (desktop.addEventListener) desktop.addEventListener('change', applyDefaults);
    else if (desktop.addListener) desktop.addListener(applyDefaults);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.bgl-nav'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
